import React from "react";
import { Link } from "react-router-dom";
import { formatBookingEffReferenceFromParts } from "../../utils/bookingUtils";

interface AutomationBookingLinkProps {
  bookingId: number;
  refs: Record<number, string>;
}

export const AutomationBookingLink: React.FC<AutomationBookingLinkProps> = ({
  bookingId,
  refs,
}) => (
  <Link to={`/admin/bookings?booking_id=${bookingId}`}>
    {refs[bookingId] ?? formatBookingEffReferenceFromParts(bookingId)}
  </Link>
);
